import React, { useContext } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"
import { Card, CardContent, Typography } from "@material-ui/core"

import UploadFileButton from "./UploadFileButton"
import { UserContext } from "../contexts/UserContext"
import { SchemaContext } from "../contexts/SchemaContext"

const useStyles = makeStyles((theme) => ({
  card: {
    "& > *": {
      margin: theme.spacing(1),
    },
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  cardContent: {
    width: 300,
  },
  input: {
    display: "none",
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  button: {
    minWidth: 300,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  wrapper: {
    position: "relative",
  },
}))

const ReferenceTablesCard = ({ saveActivity }) => {
  console.log(" SAVE ACT ", saveActivity)
  const classes = useStyles()
  //const { user } = useContext(UserContext)
  const { schema } = useContext(SchemaContext)

  const items = schema.filter((item) => item.button_type_id === 3)
  //if (!user || !["ADMIN", "USER"].includes(user.accessLevel)) return null

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          Reference Table Uploads
        </Typography>
        {items.map((item) => (
          <UploadFileButton
            key={item.id}
            label={item.label}
            context={item.folder_name}
            saveActivity={saveActivity}
          />
        ))}
      </CardContent>
    </Card>
  )
}

ReferenceTablesCard.propTypes = {
  saveActivity: PropTypes.func,
}

export default ReferenceTablesCard
